import * as Sentry from "@sentry/react";
import { env, isSentryConfigured } from "@/lib/env";

let initialized = false;
const buildId = typeof __APP_BUILD_ID__ === "string" ? __APP_BUILD_ID__ : "dev-build";

function clampSampleRate(value: number) {
  if (!Number.isFinite(value)) {
    return 0.01;
  }

  if (value < 0) {
    return 0;
  }

  if (value > 1) {
    return 1;
  }

  return value;
}

export function isSentryEnabled() {
  return env.appEnv === "production" && isSentryConfigured;
}

export function resolveSentryInitOptions() {
  if (!isSentryEnabled()) {
    return null;
  }

  return {
    dsn: env.sentryDsn,
    environment: env.appEnv,
    release: env.sentryRelease || buildId,
    tracesSampleRate: clampSampleRate(env.sentryTracesSampleRate),
    integrations: [Sentry.browserTracingIntegration()],
  } satisfies Parameters<typeof Sentry.init>[0];
}

export function initSentry() {
  const options = resolveSentryInitOptions();

  if (initialized || !options) {
    return;
  }

  Sentry.init(options);
  initialized = true;
}

export function setSentryUser(userId: string | null | undefined) {
  if (!isSentryEnabled() || !userId) {
    return;
  }

  Sentry.setUser({ id: userId });
}

export function clearSentryUser() {
  if (!isSentryEnabled()) {
    return;
  }

  Sentry.setUser(null);
}
